import React from 'react';
import { ButtonInputElement } from '../../../elements';
import { BlogsPostCardTemplateProps } from '../interfaces';

export const BlogsPostCardDefaultTemplate = (
  props: BlogsPostCardTemplateProps
) => {
  return (
    <article data-cy="blog-post-card" id={props.id} className={props.className}>
      <div
        className="blog-post-card-container"
        onClick={() => {
          props.onClick(props.handle);
        }}
      >
        <div className="blog-post-card-img-container">
          <figure className="blog-card-img-label">{props.label}</figure>
          <div
            className="blog-post-img"
            style={{
              backgroundImage: `url(${props.imgSrc})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        </div>
        <h4 className="blog-card-title">{props.title}</h4>
        <p
          className={`card-description ${
            props.shortDescription ? 'line-clamp-2' : 'line-clamp-6'
          }`}
          dangerouslySetInnerHTML={{ __html: props.description }}
        ></p>
        <div className="blog-post-card-read-more">
          <ButtonInputElement
            label="Read more"
            id="read-more"
            type="button"
            name="readMoreBtn"
            styleClasses={['buttonInputBase']}
            onClickHandler={() => undefined}
          />
        </div>
      </div>
    </article>
  );
};
